import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { StampIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const tamperingDefinition: SmartSignalDefinition<{
  tampering?: IdEventV4['tampering']
  tampering_details?: IdEventV4['tampering_details']
}> = {
  key: 'tampering',
  label: 'Tampering',
  extract: (e) => ({ tampering: e.tampering, tampering_details: e.tampering_details }),
  icon(e) {
    const p = this.extract(e)?.tampering
    return (
      <StampIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.tampering
    return p ?? false
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"tampering":',
  documentationHash: '#browser-tamper-detection',
  urlParamKey: IdentificationUrlKeys.BrowserTampering,
}
